import { Palette } from '@mui/material';
import { alpha, CSSInterpolation } from '@mui/material/styles';

export const fabRoot = (): CSSInterpolation => ({
	zIndex: 'unset',
	width: 44,
	height: 44,
	borderRadius: 22,
	'&.Mui-disabled': {
		opacity: 0.7
	},
	'&.MuiFab-sizeSmall': {
		width: 40,
		height: 40,
		borderRadius: 20
	},
	'&.MuiFab-sizeMedium': {
		width: 42,
		height: 42,
		borderRadius: 21
	}
});

export const fabExtended = (palette: Palette): CSSInterpolation => ({
	width: 'unset',
	'&.MuiFab-sizeSmall': {
		width: 'unset',
		fontSize: '12px',
		lineHeight: '12px'
	},
	'&.MuiFab-sizeMedium': {
		width: 'unset',
		fontSize: '14px',
		lineHeight: '14px'
	},
	fontWeight: 'bold',
	fontSize: '16px',
	lineHeight: '16px',
	paddingLeft: 24,
	paddingRight: 24,
	textDecoration: 'none !important',
	textTransform: 'none',
	letterSpacing: 0.75
});

export const fabSecondary = (palette: Palette): CSSInterpolation => ({
	boxShadow: 'none',
	border: '1.5px solid ' + palette.text.primary,
	color: palette.text.primary,
	backgroundColor: 'transparent',
	'&:active': {
		boxShadow: 'none'
	},
	'&:hover': {
		backgroundColor: alpha(palette.text.primary, 0.06),
		borderColor: palette.text.primary
	},
	'&.Mui-disabled': {
		border: 'none',
		opacity: 'unset',
		background: '#d8d8d8',
		color: '#9E9FA0'
	},
	'&:not(.btn)': {
		color: palette.text.primary,
		'&.Mui-disabled': {
			color: '#9E9FA0'
		},
		'&:hover': {
			color: palette.text.primary,
			textDecoration: 'none'
		}
	}
});

export const fabPrimary = (palette: Palette): CSSInterpolation => ({
	color: '#161718',
	boxShadow: 'none',
	background: palette.secondary.main,
	'&.Mui-disabled': {
		opacity: 'unset',
		background: '#d8d8d8',
		color: '#9E9FA0'
	},
	'&:hover': {
		backgroundColor: palette.secondary.light,
		color: '#161718'
	},
	'&:active': {
		boxShadow: 'none'
	},
	'&:not(.btn)': {
		color: '#161718',
		'&.Mui-disabled': {
			color: '#9E9FA0'
		},
		'&:hover': {
			backgroundColor: palette.secondary.light,
			color: '#161718',
			textDecoration: 'none'
		}
	}
});
